module.exports = __webpack_public_path__ + "img/llama.64a6b89b.png";